<div class="estimate-total ui-g-12 padding-12">
  <!-- Start Payment Button -->
  <div class="ui-g-12 p-0 item-row payment-row">
    <div class="ui-g-6 px-1 py-0" *ngIf="isShowApplyCredit && !isRevenueRecognitionSettleEnabled">
      <button id="btn-estimate-add-payment" class="custom-button btn btn-primary btn-block btn-submit font-bold font-13"
        (click)="openApplyCredit()">
        <span> +&nbsp;Apply Credit </span>
      </button>
    </div>

    <div class="px-1 py-0" [ngClass]="isShowApplyCredit && !isRevenueRecognitionSettleEnabled ? 'ui-g-6' : 'ui-g-12'">
      <ng-container *ngIf="_estimate.invoiceType === 'refund' && !canFinalizedAdjustmentInvoices else activePaymentBtn">
        <button id="btn-estimate-add-payment"
          class="custom-button btn btn-primary btn-block btn-submit font-bold font-13"
          pTooltip="Please request your store manager / admin to finalize this adjustment." [disabled]="true">
          Payment&nbsp;/&nbsp;Finalization
        </button>
      </ng-container>

      <ng-template #activePaymentBtn>
        <button id="btn-estimate-add-payment"
          class="custom-button btn btn-primary btn-block btn-submit font-bold font-13"
          [disabled]="(showPaymentLoader || isArchived || isUpdatingServices) && (!_estimate?.isInvoiceLock || _estimate?.isPaidFull)"
          (click)="addPayment()">
          <span *ngIf="isRevenueRecognitionSettleEnabled; else paymentBtnText"> Payment&nbsp;/&nbsp;Finalization </span>

          <ng-template #paymentBtnText>
            <span>+&nbsp;Payment</span>
          </ng-template>
          <i class="fal fa-spinner rotate ml-2" *ngIf="showPaymentLoader"></i>
        </button>
      </ng-template>
    </div>
  </div>
  <!-- End Payment Button -->

  <!-- Start Item totals -->
  <div class="ui-g-12 px-1 pt-0 pointer pb-1" (click)="toggleOrderDetails('isTotalDetailsVisible', $event)">
    <div class="ui-g-9 p-0 flex-start-center left-heading font-gray-light hover-underline">
      <p class="font-secondary-900 mb-0 font-13 pointer text-truncate" tooltipPosition="top"
        pTooltip="Parts + Labor + Tire + Other{{ isTireStorageEnabled ? ' + Tire Storage' : '' }}{{ isSubletTrackingEnabled ? ' + Sublet' : '' }}">
        Parts + Labor + Tire + Other{{ isTireStorageEnabled ? ' + Tire Storage' : '' }}{{ isSubletTrackingEnabled ?
        ' + Sublet' : '' }}
        <i class="ml-1 fal fa-chevron-down font-11 pointer" *ngIf="!isTotalDetailsVisible"></i>
        <i class="ml-1 fal fa-chevron-up font-11 pointer" *ngIf="isTotalDetailsVisible"></i>
      </p>
    </div>

    <div class="ui-g-3 p-0 text-right font-13 right-heading font-secondary-900 pointer hover-underline">
      {{ showItemsRawTotal() | currency : usd }}
    </div>
  </div>

  <!-- Parts total -->
  <div class="ui-g-12 pt-1 pl-1 pr-1 pb-0" *ngIf="isTotalDetailsVisible">
    <div class="ui-g-9 p-0 flex-start-center left-heading font-light">
      <p class="mb-0 font-12 pl-15">Parts:</p>
    </div>

    <div class="ui-g-3 p-0 text-right font-12 right-heading font-light pointer">
      {{ _estimate?.total?.parts | currency : usd }}
    </div>
  </div>

  <!-- Labor total -->
  <div class="ui-g-12 pt-1 pl-1 pr-1 pb-0" *ngIf="isTotalDetailsVisible">
    <div class="ui-g-9 p-0 flex-start-center left-heading font-light">
      <p class="mb-0 font-12 pl-15">Labor:</p>
    </div>

    <div class="ui-g-3 p-0 text-right font-12 right-heading font-light pointer">
      {{ _estimate?.total?.labor | currency : usd }}
    </div>
  </div>

  <!-- Tire total -->
  <div class="ui-g-12 pt-1 pl-1 pr-1 pb-0" *ngIf="isTotalDetailsVisible">
    <div class="ui-g-9 p-0 flex-start-center left-heading font-light">
      <p class="mb-0 font-12 pl-15">Tire:</p>
    </div>

    <div class="ui-g-3 p-0 text-right font-12 right-heading font-light pointer">
      {{ _estimate?.total?.tire | currency : usd }}
    </div>
  </div>

  <!-- Tire storage total -->
  <div class="ui-g-12 pt-1 pl-1 pr-1 pb-0" *ngIf="isTireStorageEnabled && isTotalDetailsVisible">
    <div class="ui-g-9 p-0 flex-start-center left-heading font-light">
      <p class="mb-0 font-12 pl-15">Tire Storage:</p>
    </div>

    <div class="ui-g-3 p-0 text-right font-12 right-heading font-light pointer">
      {{ _estimate?.total?.tireStorage | currency : usd }}
    </div>
  </div>

  <!-- Sublet Total total -->
  <div class="ui-g-12 pt-1 pl-1 pr-1 pb-0" *ngIf="isSubletTrackingEnabled && isTotalDetailsVisible">
    <div class="ui-g-9 p-0 flex-start-center left-heading font-light">
      <p class="mb-0 font-12 pl-15">Sublet:</p>
    </div>

    <div class="ui-g-3 p-0 text-right font-12 right-heading font-light pointer">
      {{ _estimate?.total?.sublet || 0 | currency : usd }}
    </div>
  </div>

  <!-- Other total -->
  <div class="ui-g-12 p-1" *ngIf="isTotalDetailsVisible">
    <div class="ui-g-9 p-0 flex-start-center left-heading font-light">
      <p class="mb-0 font-12 pl-15">Other:</p>
    </div>

    <div class="ui-g-3 p-0 text-right font-12 right-heading font-light pointer">
      {{ _estimate?.total?.other | currency : usd }}
    </div>
  </div>
  <!-- End Item totals -->

  <!-- Start Item Discount -->
  <div class="ui-g-12 p-1 font-gray-light font-13">
    <div class="font-secondary-900 ui-g-9 p-0 flex-start-center left-heading">
      {{ isDiscountItemEnabled ? 'Item Discount' : 'Service Discount' }}
    </div>

    <div class="font-secondary-900 ui-g-3 p-0 text-right right-heading">
      <span *ngIf="!isDiscountItemEnabled; else discountItemSection"> ({{ _estimate.total.itemDiscountedAmount |
        currency : usd }}) </span>

      <ng-template #discountItemSection>
        <span>({{ _estimate.total.itemLevelDiscount | currency : usd }})</span>
      </ng-template>
    </div>
  </div>
  <!-- End Item Discount -->

  <!-- Start Service Discount -->
  <div *ngIf="isDiscountItemEnabled" class="ui-g-12 p-1 font-gray-light font-13">
    <div class="font-secondary-900 ui-g-9 p-0 flex-start-center left-heading">
      <p class="font-secondary-900 mb-0 font-13 pointer text-truncate hover-underline" tooltipPosition="top"
        (click)="toggleOrderDetails('isServiceDiscountDistVisible', $event)">
        Service Discount
        <i class="ml-1 fal fa-chevron-down font-11 pointer" *ngIf="!isServiceDiscountDistVisible"></i>
        <i class="ml-1 fal fa-chevron-up font-11 pointer" *ngIf="isServiceDiscountDistVisible"></i>
      </p>
    </div>

    <div class="font-secondary-900 ui-g-3 p-0 text-right right-heading">
      <span>({{ _estimate.total.serviceLevelDiscount | currency : usd }})</span>
    </div>
  </div>

  <div *ngFor="let serviceDiscount of serviceDiscountList" class="ui-g-12 p-1" [hidden]="!isServiceDiscountDistVisible">
    <div class="ui-g-9 p-0 flex-start-center left-heading font-light">
      <p class="mb-0 font-12 flex-start-center text-truncate pl-15">
        {{ currentLang === 'fr' ? (serviceDiscount?.titleFR || serviceDiscount?.title) : (serviceDiscount?.title ||
        serviceDiscount?.titleFR) }}
      </p>
    </div>

    <div class="ui-g-3 p-0 text-right font-12 right-heading font-light">
      {{ serviceDiscount?.amount || 0 | currency : usd }}
    </div>
  </div>
  <!-- End Service Discount -->

  <!-- Start Hazmat Fees -->
  <div class="ui-g-12 p-1 font-gray-light font-13">
    <div class="font-secondary-900 ui-g-9 p-0 flex-start-center left-heading">Service Level Fees</div>
    <div class="font-secondary-900 ui-g-3 p-0 text-right right-heading">
      {{ _estimate.total.hazmatFee || 0 | currency : usd }}
    </div>
  </div>
  <!-- End Hazmat Fees -->

  <!-- Start RO Fee -->
  <div *ngIf="_estimate?.isRoLevelFeeEnabled" class="ui-g-12 p-1">
    <div class="ui-g-9 p-0 flex-start-center left-heading font-gray-light">
      <p class="font-secondary-900 mb-0 font-13 pointer text-truncate hover-underline" tooltipPosition="top"
        (click)="toggleOrderDetails('isTotalRoDetailsVisible', $event)">
        RO Fees
        <i class="ml-1 fal fa-chevron-down font-11 pointer" *ngIf="!isTotalRoDetailsVisible"></i>
        <i class="ml-1 fal fa-chevron-up font-11 pointer" *ngIf="isTotalRoDetailsVisible"></i>
      </p>

      <app-content-overlay [dropshadow]="false" [showArrow]="false" right="-72%" [closeAfterAction]="closeAfterAction"
        [ngClass]="{ 'disabled-estimate-field': isArchived }">
        <ng-template appTemplate="item">
          <span class="font-13 pointer font-primary hover-underline pl-2"> Add Fee </span>
        </ng-template>

        <ng-template appTemplate="overlay" let-close="close">
          <div class="filter-overlay filter-height w-160">
            <div *ngFor="let roFeeType of _roAllFeeTypesOption; index as i" class="pointer filter-option"
              [hidden]="roFeeType.isAdded" (click)="handleSelectFees(roFeeType, close)">
              <span>{{ currentLang === 'fr' ? (roFeeType?.nameFR || roFeeType?.name) : (roFeeType?.name ||
                roFeeType?.nameFR) }}</span>

              <i *ngIf="_estimate?.adjustments?.isApplied && !_estimate?.adjustments?.isRoundDown"
                class="far fa-edit ro-discount-icon font-gray-85" tooltipPosition="top"
                [pTooltip]="shopSuppliesDistributionTooltip" [escape]="false"></i>
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>

    <div class="ui-g-3 p-0 text-right font-13 right-heading font-secondary-900">
      {{ _estimate?.total?.totalFee || 0 | currency : usd }}
    </div>
  </div>

  <!-- RO Fee Sub Items -->
  <div class="ui-g-12 pt-1 pl-1 pr-1 pb-0 mouse-over pl-15" [hidden]="!isTotalRoDetailsVisible"
    *ngFor="let feeItem of _roFeesList; index as i">
    <span (mouseover)="feeItem.showDeleteOption = true" (mouseout)="feeItem.showDeleteOption = false">
      <app-content-overlay right="40" [showArrow]="false" [disabled]="isArchived">
        <ng-template appTemplate="item">
          <div class="ui-g-9 p-0 flex-start-center left-heading font-light">
            <p class="mb-0 font-12 flex-start-center">
              <span>{{ currentLang === 'fr' ? (feeItem?.nameFR || feeItem?.name) : (feeItem?.name || feeItem?.nameFR)
                }}</span>
              <span *ngIf="feeItem?.type === 'percentage'">&nbsp;({{ feeItem?.value }}%)</span>
              <i *ngIf="feeItem?.isShopSupply && _estimate?.adjustments?.isApplied && !_estimate?.adjustments?.isRoundDown"
                class="far fa-edit ro-discount-icon font-gray-85" tooltipPosition="top"
                [pTooltip]="shopSuppliesDistributionTooltip" [escape]="false"></i>
            </p>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay" let-close="close">
          <div class="shop-supplies-overlay">
            <div class="overlay-header">
              <span class="font-13 flex-start-center font-secondary-900 font-bold">
                <span>{{ currentLang === 'fr' ? (feeItem?.nameFR || feeItem?.name) : (feeItem?.name || feeItem?.nameFR)
                  }}</span>
              </span>
            </div>

            <div class="overlay-content-wrapper">
              <div class="input-box d-flex">
                <div class="dropdown-box">
                  <app-dropdown id="order-shop-supplies-dropdown" theme="light" styleClassSelectedView="pl-0"
                    styleClass="pl-0" placeholder="Calculation" [floatingLabel]="true" itemWidth="120px" [fontSize]="12"
                    [value]="config.estimate.discountType[feeItem?.type === 'percentage' ? 0 : 1]"
                    [isDropdownIconVisible]="true" (appSelect)="onOrderFeeChange('type', $event, feeItem)"
                    [disabled]="isArchived" [options]="config.estimate.discountType">
                  </app-dropdown>
                </div>

                <div class="input-box">
                  <app-input id="order-shop-supplies-input"
                    [mask]="isFocus ? (feeItem?.type === 'value' ? '' : 'percent') : ''" [fontSize]="12"
                    [allowDecimal]="isFocus ? (feeItem?.type === 'value' ? true : false) : false" styleClass="pl-0"
                    styleClassInput="pl-0" theme="light" placeholder="Value" [floatingLabel]="true"
                    [value]="feeItem?.value" [disabled]="isArchived"
                    (appChange)="onOrderFeeChange('value', $event, feeItem)" (appFocus)="isFocus = true"
                    (appBlur)="isFocus = false" (appEnter)="doneOrderFee(close, feeItem?.feeId)">
                  </app-input>
                </div>
              </div>
            </div>

            <div class="overlay-footer-wrapper">
              <div class="flex-end-center">
                <span id="order-shop-supplies-cancel-btn"
                  class="btn btn-white btn-border overlay-panel-btn flex-center-center p-0 mr-1 pl-2 pr-2"
                  (click)="close()"> Cancel </span>

                <button id="order-shop-supplies-save-btn"
                  class="btn btn-primary overlay-panel-btn flex-center-center p-0 pl-2 pr-2"
                  (click)="doneOrderFee(close, feeItem?.feeId, feeItem?.isShopSupply)" [disabled]="isArchived">
                  Save
                </button>
              </div>
            </div>
          </div>
        </ng-template>
      </app-content-overlay>

      <div class="ui-g-3 p-0 text-right font-12 right-heading font-light" [ngClass]="{ 'not-allowed': isArchived }">
        {{ feeItem?.feeCalcValue | currency : usd }}
        <i class="fa fa-trash pl-2" aria-hidden="true" (click)="deleteROFee(i)"></i>
      </div>
    </span>
  </div>
  <!-- End RO Fee subitems -->

  <!-- Start Shop supplies -->
  <div *ngIf="!_estimate?.isRoLevelFeeEnabled && _estimate?.isShopFeeEnabled && _estimate?.shopFeeBeforeDiscount"
    class="font-secondary-900 ui-g-12 p-1 font-gray-light font-13">
    <div class="ui-g-9 p-0 service-shop-supplies-overlay flex-start-center">
      <app-content-overlay right="40" [showArrow]="false" (appShow)="handleOpenShopSupplies()">
        <ng-template appTemplate="item">
          <span class="hover-underline position-relative">
            Shop&nbsp;supplies&nbsp;({{ _estimate?.total?.shopFeePercent || 0 }}%)
            <i *ngIf="_estimate?.adjustments?.isApplied && !_estimate?.adjustments?.isRoundDown"
              class="far fa-edit ro-discount-icon font-gray-85" tooltipPosition="top"
              [pTooltip]="shopSuppliesDistributionTooltip" [escape]="false"></i>
          </span>
        </ng-template>

        <ng-template appTemplate="overlay" let-close="close">
          <div class="shop-supplies-overlay">
            <div class="overlay-header">
              <span class="font-13 font-secondary-900 font-bold"> Shop supplies </span>
            </div>
            <div class="overlay-content-wrapper">
              <div class="input-box d-flex">
                <div class="dropdown-box">
                  <app-dropdown id="order-shop-supplies-dropdown" theme="light" styleClassSelectedView="pl-0"
                    styleClass="pl-0" placeholder="Calculation" [floatingLabel]="true" itemWidth="120px" [fontSize]="12"
                    [value]="selectedShopSupplies" [isDropdownIconVisible]="true"
                    (appSelect)="onShopSuppliesChange('type', $event)" [disabled]="isArchived"
                    [options]="config.estimate.discountType">
                  </app-dropdown>
                </div>

                <div class="input-box">
                  <app-input id="order-shop-supplies-input"
                    [mask]="isFocus ? (selectedShopSupplies.type === 'value' ? '' : 'percent') : ''"
                    [allowDecimal]="isFocus ? (selectedShopSupplies.type === 'value' ? true : false) : false"
                    [fontSize]="12" styleClass="pl-0" styleClassInput="pl-0" theme="light" placeholder="Value"
                    [floatingLabel]="true" [value]="selectedShopSupplies.value" [disabled]="isArchived"
                    (appChange)="onShopSuppliesChange('input', $event)" (appFocus)="isFocus = true"
                    (appBlur)="isFocus = false" (appEnter)="doneSuppliesFees(close)">
                  </app-input>
                </div>
              </div>
            </div>

            <div class="overlay-footer-wrapper">
              <div class="flex-end-center">
                <span id="order-shop-supplies-cancel-btn"
                  class="btn btn-white btn-border overlay-panel-btn flex-center-center p-0 mr-1 pl-2 pr-2"
                  (click)="close()"> Cancel </span>

                <button id="order-shop-supplies-save-btn"
                  class="btn btn-primary overlay-panel-btn flex-center-center p-0 pl-2 pr-2"
                  (click)="doneSuppliesFees(close)" [disabled]="isArchived">
                  Save
                </button>
              </div>
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>

    <div class="font-secondary-900 ui-g-3 p-0 flex-end-center">
      <span id="order-shop-supplies-link" class="font-secondary-900">
        <p class="m-0">
          {{ _estimate.total?.shopFee || 0 | currency : usd }}
        </p>
      </span>
    </div>
  </div>
  <!-- End Shop supplies -->

  <!-- Start Shop supplies -->
  <div
    *ngIf="!_estimate?.isRoLevelFeeEnabled && !_estimate?.isShopFeeEnabled && companyShopSuppliesEnabled && _estimate?.shopFeeBeforeDiscount"
    class="font-secondary-900 ui-g-12 p-1 font-gray-light font-13">
    <div class="ui-g-9 p-0 flex-start-center position-relative">
      Shop&nbsp;supplies
      <i *ngIf="_estimate?.adjustments?.isApplied && !_estimate?.adjustments?.isRoundDown"
        class="far fa-edit ro-discount-icon font-gray-85" tooltipPosition="top"
        [pTooltip]="shopSuppliesDistributionTooltip" [escape]="false"></i>
    </div>

    <div class="service-shop-supplies-overlay-add font-secondary-900 ui-g-3 p-0 flex-end-center">
      <span id="order-shop-supplies-link" class="font-secondary-900">
        <app-content-overlay right="40" [showArrow]="false">
          <ng-template appTemplate="item">
            <span class="font-primary"> Add </span>
          </ng-template>

          <ng-template appTemplate="overlay" let-close="close">
            <div class="shop-supplies-overlay">
              <div class="overlay-header">
                <span class="font-13 font-secondary-900 font-bold"> Shop supplies </span>
              </div>
              <div class="overlay-content-wrapper">
                <div class="input-box d-flex">
                  <div class="dropdown-box">
                    <app-dropdown id="order-shop-supplies-dropdown" theme="light" styleClassSelectedView="pl-0"
                      styleClass="pl-0" placeholder="Calculation" [floatingLabel]="true" itemWidth="120px"
                      [fontSize]="12" [value]="selectedShopSupplies" [disabled]="isArchived"
                      [isDropdownIconVisible]="true" (appSelect)="onShopSuppliesChange('type', $event)"
                      [options]="config.estimate.discountType">
                    </app-dropdown>
                  </div>

                  <div class="input-box">
                    <app-input id="order-shop-supplies-input"
                      [mask]="isFocus ? (selectedShopSupplies.type === 'value' ? '' : 'percent') : ''"
                      [allowDecimal]="isFocus ? (selectedShopSupplies.type === 'value' ? true : false) : false"
                      [fontSize]="12" styleClass="pl-0" styleClassInput="pl-0" theme="light" placeholder="Value"
                      [floatingLabel]="true" [value]="selectedShopSupplies.value" [disabled]="isArchived"
                      (appChange)="onShopSuppliesChange('input', $event)" (appFocus)="isFocus = true"
                      (appBlur)="isFocus = false" (appEnter)="doneSuppliesFees(close)">
                    </app-input>
                  </div>
                </div>
              </div>

              <div class="overlay-footer-wrapper p-2">
                <div class="flex-end-center mt-1">
                  <button id="order-shop-supplies-cancel-btn"
                    class="btn btn-white btn-border overlay-panel-btn flex-center-center p-0 mr-1 pl-2 pr-2"
                    (click)="close()">Cancel</button>

                  <button id="order-shop-supplies-save-btn"
                    class="btn btn-primary overlay-panel-btn flex-center-center p-0 pl-2 pr-2" [disabled]="isArchived"
                    (click)="doneSuppliesFees(close)">
                    Save
                  </button>
                </div>
              </div>
            </div>
          </ng-template>
        </app-content-overlay>
      </span>
    </div>
  </div>
  <!-- End Shop supplies -->

  <!-- Start Order Discount -->
  <div *ngIf="!isDiscountItemEnabled" class="font-secondary-900 ui-g-12 p-1 font-gray-light font-13">
    <div class="ui-g-9 p-0 service-discount-overlay flex-start-center left-heading">
      <app-content-overlay right="auto" [showArrow]="false" (appShow)="handleOpenDiscount()">
        <ng-template appTemplate="item">
          <span id="order-discount-link" class="font-secondary-900 hover-underline position">
            Order Discount ({{ renderDiscount() || 0 | number : '1.2-2' }}%)
            <i *ngIf="_estimate?.adjustments?.isApplied && _estimate?.adjustments?.isRoundDown"
              class="far fa-edit ro-discount-icon font-gray-85" tooltipPosition="top"
              [pTooltip]="discountDistributionTooltip" [escape]="false"></i>
          </span>
        </ng-template>

        <ng-template appTemplate="overlay" let-close="close">
          <div class="discount-overlay">
            <div class="overlay-header">
              <span class="font-13 font-secondary-900 font-bold"> Order Discount </span>
            </div>

            <div class="overlay-content-wrapper">
              <div class="input-box d-flex">
                <div class="dropdown-box">
                  <app-dropdown id="order-discount-dropdown" theme="primary" styleClassSelectedView="pl-0"
                    styleClass="pl-0" itemWidth="120px" placeholder="Calculation" [floatingLabel]="true" [fontSize]="12"
                    [value]="selectedDiscount" [isDropdownIconVisible]="true" [disabled]="isArchived"
                    (appSelect)="onDiscountChange('type', $event)" [options]="discountTypeOptions">
                  </app-dropdown>
                </div>

                <div class="input-box">
                  <app-input id="order-discount-input" styleClass="pl-0" styleClassInput="pl-0" placeholder="Value"
                    [mask]="isFocus ? (selectedDiscount.type === 'value' ? '' : 'percent') : ''"
                    [allowDecimal]="isFocus ? (selectedDiscount.type === 'value' ? true : false) : false"
                    [fontSize]="12" [floatingLabel]="true" [disabled]="isArchived"
                    [value]="selectedDiscount.value ? selectedDiscount.value : ''"
                    (appChange)="onDiscountChange('input', $event)" (appFocus)="isFocus = true"
                    (appBlur)="isFocus = false" (appEnter)="doneDisc(close)"></app-input>
                </div>
              </div>
            </div>

            <div class="overlay-footer-wrapper">
              <div class="flex-end-center mt-1">
                <span id="order-discount-cancel-btn" class="btn-cancel btn-50 text-center mr-1"
                  (click)="close()">Cancel</span>
                <button id="order-discount-save-btn" class="btn-save btn-50 text-center" [disabled]="isArchived"
                  (click)="doneDisc(close)">Save</button>
              </div>
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <div class="font-secondary-900 ui-g-3 p-0 text-right right-heading">({{ _estimate.total.discountedAmount | currency
      : usd }})</div>
  </div>
  <!-- End Order Discount -->

  <!-- Start Order Discount Enhanced -->
  <div *ngIf="isDiscountItemEnabled" class="ui-g-12 p-1">
    <div class="ui-g-9 p-0 flex-start-center left-heading font-gray-light">
      <p class="font-secondary-900 mb-0 font-13 pointer text-truncate hover-underline" tooltipPosition="top"
        (click)="toggleOrderDetails('isOrderDiscountDistVisible', $event)">
        Order Discount
        <i class="ml-1 fal fa-chevron-down font-11 pointer" *ngIf="!isOrderDiscountDistVisible"></i>
        <i class="ml-1 fal fa-chevron-up font-11 pointer" *ngIf="isOrderDiscountDistVisible"></i>
      </p>

      <app-content-overlay [dropshadow]="false" [showArrow]="false" right="-72%" [closeAfterAction]="closeAfterAction"
        [ngClass]="{ 'disabled-estimate-field': isArchived }">
        <ng-template appTemplate="item">
          <span class="font-13 pointer font-primary hover-underline pl-2"> Add Discount </span>
        </ng-template>

        <ng-template appTemplate="overlay" let-close="close">
          <div class="filter-overlay filter-height w-160">
            <div *ngFor="let orderOption of _orderLevelDiscountOptions; index as i" class="pointer filter-option"
              [hidden]="orderOption.isAdded" (click)="handleSelectOrderDiscount(orderOption, close)">
              <span>{{ currentLang === 'fr' ? (orderOption?.titleFR || orderOption?.title) : (orderOption?.title ||
                orderOption?.titleFR) }}</span>
            </div>
          </div>
          <div class="pointer p-1 filter-option font-primary background-gray-95" (click)="handleCreatedDiscount(close)">
            <span>Create discount</span>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>

    <div class="ui-g-3 p-0 text-right font-13 right-heading font-secondary-900">({{ _estimate?.total?.discountedAmount
      || 0 | currency : usd }})</div>
  </div>

  <div *ngFor="let discountItem of _orderDiscountList; index as i" class="ui-g-12 p-1 mouse-over"
    [hidden]="!isOrderDiscountDistVisible">
    <span (mouseover)="discountItem.showDeleteOption = true" (mouseout)="discountItem.showDeleteOption = false">
      <div class="ui-g-9 p-0 flex-start-center left-heading font-light">
        <p class="mb-0 font-12 flex-start-center hover-underline"
          (click)="handleOpenItemDialog(discountItem, 'discount', i)">
          <span class="pl-15 position-relative">
            {{ currentLang === 'fr' ? (discountItem?.nameFR || discountItem?.name) : (discountItem?.name ||
            discountItem?.nameFR) }}
            <i *ngIf="discountItem?.isDefault && _estimate?.adjustments?.isApplied && _estimate?.adjustments?.isRoundDown"
              class="far fa-edit ro-discount-icon font-gray-85" tooltipPosition="top"
              [pTooltip]="discountDistributionTooltip" [escape]="false"></i>
          </span>
        </p>
      </div>

      <div class="ui-g-3 p-0 text-right font-12 right-heading font-light" [ngClass]="{ 'not-allowed': isArchived }">
        {{ discountItem?.discountCalcValue | currency : usd }}
        <i class="fa fa-trash pl-2" aria-hidden="true" (click)="handleDeleteOrderDiscount(i)"></i>
      </div>
    </span>
  </div>
  <!-- End Order Discount Enhanced -->

  <!-- Start Shop supplies -->
  <div *ngIf="!_estimate?.isRoLevelFeeEnabled && _estimate?.isShopFeeEnabled && !_estimate.shopFeeBeforeDiscount"
    class="font-secondary-900 ui-g-12 p-1 font-gray-light font-13">
    <div class="ui-g-9 p-0 service-shop-supplies-overlay flex-start-center">
      <app-content-overlay right="40" [showArrow]="false" (appShow)="handleOpenShopSupplies()">
        <ng-template appTemplate="item">
          <span class="hover-underline position-relative">
            Shop&nbsp;supplies&nbsp;({{ _estimate?.total?.shopFeePercent || 0 }}%)
            <i *ngIf="_estimate?.adjustments?.isApplied && !_estimate?.adjustments?.isRoundDown"
              class="far fa-edit ro-discount-icon font-gray-85" tooltipPosition="top"
              [pTooltip]="shopSuppliesDistributionTooltip" [escape]="false"></i>
          </span>
        </ng-template>

        <ng-template appTemplate="overlay" let-close="close">
          <div class="shop-supplies-overlay">
            <div class="overlay-header">
              <span class="font-13 font-secondary-900 font-bold"> Shop supplies </span>
            </div>
            <div class="overlay-content-wrapper">
              <div class="input-box d-flex">
                <div class="dropdown-box">
                  <app-dropdown id="order-shop-supplies-dropdown" theme="light" styleClassSelectedView="pl-0"
                    styleClass="pl-0" placeholder="Calculation" [floatingLabel]="true" itemWidth="120px" [fontSize]="12"
                    [value]="selectedShopSupplies" [isDropdownIconVisible]="true"
                    (appSelect)="onShopSuppliesChange('type', $event)" [disabled]="isArchived"
                    [options]="config.estimate.discountType">
                  </app-dropdown>
                </div>

                <div class="input-box">
                  <app-input id="order-shop-supplies-input"
                    [mask]="isFocus ? (selectedShopSupplies.type === 'value' ? '' : 'percent') : ''"
                    [allowDecimal]="isFocus ? (selectedShopSupplies.type === 'value' ? true : false) : false"
                    [fontSize]="12" styleClass="pl-0" styleClassInput="pl-0" theme="light" placeholder="Value"
                    [floatingLabel]="true" [value]="selectedShopSupplies.value" [disabled]="isArchived"
                    (appChange)="onShopSuppliesChange('input', $event)" (appFocus)="isFocus = true"
                    (appBlur)="isFocus = false" (appEnter)="doneSuppliesFees(close)">
                  </app-input>
                </div>
              </div>
            </div>

            <div class="overlay-footer-wrapper">
              <div class="flex-end-center mt-1">
                <span id="order-shop-supplies-cancel-btn"
                  class="btn btn-white btn-border overlay-panel-btn flex-center-center p-0 mr-1 pl-2 pr-2"
                  (click)="close()"> Cancel </span>

                <button id="order-shop-supplies-save-btn"
                  class="btn btn-primary overlay-panel-btn flex-center-center p-0 pl-2 pr-2"
                  (click)="doneSuppliesFees(close)" [disabled]="isArchived">
                  Save
                </button>
              </div>
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>

    <div class="font-secondary-900 ui-g-3 p-0 flex-end-center">
      <span id="order-shop-supplies-link" class="font-secondary-900">
        <p class="m-0">
          {{ _estimate.total?.shopFee || 0 | currency : usd }}
        </p>
      </span>
    </div>
  </div>
  <!-- End Shop supplies -->

  <!-- Start Shop supplies -->
  <div *ngIf="!_estimate?.isShopFeeEnabled && companyShopSuppliesEnabled && !_estimate.shopFeeBeforeDiscount"
    class="font-secondary-900 ui-g-12 p-1 font-gray-light font-13">
    <div class="ui-g-9 p-0 flex-start-center position-relative">
      Shop&nbsp;supplies

      <i *ngIf="_estimate?.adjustments?.isApplied && !_estimate?.adjustments?.isRoundDown"
        class="far fa-edit ro-discount-icon font-gray-85" tooltipPosition="top"
        [pTooltip]="shopSuppliesDistributionTooltip" [escape]="false"></i>
    </div>

    <div class="service-shop-supplies-overlay-add font-secondary-900 ui-g-3 p-0 flex-end-center">
      <span id="order-shop-supplies-link" class="font-secondary-900">
        <app-content-overlay right="40" [showArrow]="false">
          <ng-template appTemplate="item">
            <span class="font-primary"> Add </span>
          </ng-template>

          <ng-template appTemplate="overlay" let-close="close">
            <div class="shop-supplies-overlay">
              <div class="overlay-header">
                <span class="font-13 font-secondary-900 font-bold"> Shop supplies </span>
              </div>
              <div class="overlay-content-wrapper">
                <div class="input-box d-flex">
                  <div class="dropdown-box">
                    <app-dropdown id="order-shop-supplies-dropdown" theme="light" styleClassSelectedView="pl-0"
                      styleClass="pl-0" placeholder="Calculation" [floatingLabel]="true" itemWidth="120px"
                      [fontSize]="12" [value]="selectedShopSupplies" [disabled]="isArchived"
                      [isDropdownIconVisible]="true" (appSelect)="onShopSuppliesChange('type', $event)"
                      [options]="config.estimate.discountType">
                    </app-dropdown>
                  </div>

                  <div class="input-box">
                    <app-input id="order-shop-supplies-input"
                      [mask]="isFocus ? (selectedShopSupplies.type === 'value' ? '' : 'percent') : ''"
                      [allowDecimal]="isFocus ? (selectedShopSupplies.type === 'value' ? true : false) : false"
                      [fontSize]="12" styleClass="pl-0" styleClassInput="pl-0" theme="light" placeholder="Value"
                      [floatingLabel]="true" [value]="selectedShopSupplies.value" [disabled]="isArchived"
                      (appChange)="onShopSuppliesChange('input', $event)" (appFocus)="isFocus = true"
                      (appBlur)="isFocus = false" (appEnter)="doneSuppliesFees(close)">
                    </app-input>
                  </div>
                </div>
              </div>

              <div class="overlay-footer-wrapper">
                <div class="flex-end-center mt-1">
                  <button id="order-shop-supplies-cancel-btn"
                    class="btn btn-white btn-border overlay-panel-btn flex-center-center p-0 mr-1 pl-2 pr-2"
                    (click)="close()">Cancel</button>

                  <button id="order-shop-supplies-save-btn"
                    class="btn btn-primary overlay-panel-btn flex-center-center p-0 pl-2 pr-2" [disabled]="isArchived"
                    (click)="doneSuppliesFees(close)">
                    Save
                  </button>
                </div>
              </div>
            </div>
          </ng-template>
        </app-content-overlay>
      </span>
    </div>
  </div>
  <!-- End Shop supplies -->

  <!-- Start Service Discount -->
  <div class="ui-g-12 p-0 font-gray-light font-13">
    <div class="font-secondary-900 ui-g-9 p-1 font-600 flex-start-center left-heading">Subtotal</div>
    <div class="ui-g-3 p-1 text-right right-heading b-top-gray-85 b-bottom-gray-85">
      <span id="est-subtotal-aft-discount" class="font-secondary-900 font-600">
        {{ _estimate?.total?.afterDiscount || 0 | currency : usd }}
      </span>
    </div>
  </div>
  <!-- End Service Discount -->
  <!-- start Passthrough Tax -->
  <div class="ui-g-12 px-1 pt-0 pointer pb-1" *ngIf="isPassThroughTaxEnable"
    (click)="toggleOrderDetails('isTotalPassThroughVisible', $event)">
    <div class="ui-g-9 p-0 flex-start-center left-heading font-gray-light hover-underline">
      <p class="font-secondary-900 mb-0 font-13 pointer text-truncate">
        Passthrough Taxes
        <i class="ml-1 fal fa-chevron-down font-11 pointer" *ngIf="!isTotalPassThroughVisible"></i>
        <i class="ml-1 fal fa-chevron-up font-11 pointer" *ngIf="isTotalPassThroughVisible"></i>
      </p>
    </div>

    <div class="ui-g-3 p-0 text-right font-13 right-heading font-secondary-900 pointer hover-underline">
      {{ _estimate?.total?.passThroughTax || 0 | currency : usd }}
    </div>
  </div>

  <!-- Passthrough dropdwon -->
  <span *ngIf="isTotalPassThroughVisible && passThroughTaxRates.length">
    <div class="ui-g-12 pt-1 pl-1 pr-1 pb-0" *ngFor="let passThroughTaxRates of passThroughTaxRates; index as i">
      <div class="ui-g-9 p-0 flex-start-center left-heading font-light">
        <p class="mb-0 font-12 pl-15">{{ helperService.getLocalizationValue(currentLang, passThroughTaxRates, 'name')}}</p>
      </div>

      <div class="ui-g-3 p-0 text-right font-12 right-heading font-light pointer">
        {{ passThroughTaxRates?.amount | currency : usd }}
      </div>
    </div>
  </span>

  <!-- End Passthrough dropdwon -->

  <!-- Start Order Tax -->
  <div class="ui-g-12 p-1 font-gray-light font-13 hover-underline pointers">
    <div class="ui-g-9 p-0 flex-start-center total-tax-overlay left-heading">
      <span *ngIf="_estimate?.customer?.taxExempt" tooltipPosition="top" [pTooltip]="generateTooltip()"
        [escape]="false">
        <span class="font-gray-light order-tax">Taxes ({{ selectedTax?.name }})</span>
      </span>

      <app-dropdown *ngIf="!_estimate?.customer?.taxExempt" field="name" itemWidth="140px" scrollHeight="150px"
        [options]="taxes" [value]="selectedTax" [disabled]="_estimate?.invoiceType || isArchived"
        [fontSize]="13" [hasCustomOpenTemplate]="true"
        (appSelect)="onTaxChange($event)">
        <ng-template let-item appTemplate="open-dropdown-btn">
          <span class="font-13 order-tax font-light" tooltipStyleClass="taxesTooltip" tooltipPosition="top"
            [pTooltip]="generateTooltip()" [escape]="false">
            Taxes
            <span *ngIf="!taxMap[selectedTax?._id]">({{ selectedTax?.name }})</span>
            <span *ngIf="taxMap[selectedTax?._id]">({{ taxMap[selectedTax?._id]?.name }} - {{ selectedTax?.value ?
              selectedTax?.value : selectedTax?.salesTaxRate }}%) </span>
            <span *ngIf="taxMap[selectedTax?.id]?.salesTaxRate != selectedTax?.value"> &nbsp;(expired) </span>
          </span>
          <i class="ml-1 fal fa-chevron-down font-11"></i>
        </ng-template>
      </app-dropdown>
      <!-- <ng-container *ngIf="isTaxDetailsBreakDown">
        <span (click)="toggleOrderDetails('isShowTaxDetails', $event)">
          <i class="ml-1 fal fa-chevron-down font-11 pointer" *ngIf="!isShowTaxDetails"></i>
          <i class="ml-1 fal fa-chevron-up font-11 pointer" *ngIf="isShowTaxDetails"></i>
        </span>
      </ng-container> -->
    </div>

    <div class="font-gray-light ui-g-3 p-0 text-right right-heading">
      <span id="est-taxed-amount"
        [ngClass]="'font-gray-light hover-underline pointers py-1 pl-1' + (isShowTaxDetails ? ' mr-3' : '')">
        {{ _estimate.total.taxedAmount | currency : usd }}
      </span>
    </div>
  </div>
  <!-- End Order Tax -->

  <!-- start Tax Sub Items -->
  <ng-container *ngIf="isTaxDetailsBreakDown">
    <div class="ui-g-12 pt-1 pl-1 pr-1 pb-0" [hidden]="!isShowTaxDetails"
      *ngFor="let taxItem of _estimate?.taxValues?.taxRates; index as i">
      <div class="ui-g-9 p-0 flex-start-center left-heading font-light">
        <p class="mb-0 font-12 pl-15">
          {{ taxItem?.name + ' - ' + taxItem?.salesTaxRate + '%' }}
        </p>
      </div>
      <div class="ui-g-3 p-0 text-right font-12 right-heading font-light">
        {{ taxItem?.taxAmount | currency : usd }}
      </div>
    </div>
  </ng-container>

  <!-- End Tax sub items -->

  <div class="ui-g-12 pt-1 pl-1 pr-1 pb-0" *ngIf="isTaxDetailsVisible">
    <div class="ui-g-9 p-0 flex-start-center left-heading font-gray-light">
      <p class="font-light mb-0 font-12">Taxable:</p>
    </div>

    <div id="est-taxable-amount" class="font-light ui-g-3 p-0 text-right font-12 right-heading pointer">
      {{ _estimate?.total?.taxableAmount || 0 | currency : usd }}
    </div>
  </div>

  <div class="ui-g-12 p-1" *ngIf="isTaxDetailsVisible">
    <div class="ui-g-9 p-0 flex-start-center left-heading font-light">
      <p class="font-light mb-0 font-12">Non-Taxable:</p>
    </div>

    <div *ngIf="_estimate?.total?.nonTaxableAmount >= 0" id="est-non-taxable-amount"
      class="font-light ui-g-3 p-0 text-right font-12 right-heading pointer">
      {{ _estimate?.total?.nonTaxableAmount || 0 | currency : usd }}
    </div>

    <div *ngIf="_estimate?.total?.nonTaxableAmount < 0" id="est-non-taxable-amount"
      class="font-light ui-g-3 p-0 text-right font-12 right-heading pointer">
      ({{ (_estimate?.total?.nonTaxableAmount || 0) * -1 | currency : usd }})
    </div>
  </div>

  <!-- Start Estimate total -->
  <div class="ui-g-12 p-0 font-gray-light font-13 position-relative">
    <div class="font-secondary-900 ui-g-9 p-1 font-600 flex-start-center left-heading position-relative">
      <!-- [showOnClick]="false" [disabled]="_estimate?.invoiceType || isArchived" -->
      <app-content-overlay right="40" [ngClass]="{ 'not-allowed': isArchived }" [showArrow]="false"
        [showOnClick]="false" [disabled]="isArchived" (appShow)="roAdjustAmount = _estimate.total.grand">
        <ng-template appTemplate="item" let-open="open">
          <span class="font-600"> {{ orderTitle }} total </span>

          <i *ngIf="_estimate?.adjustments?.isApplied" class="far fa-redo ro-adjust-reset-icon font-gray-85"
            [ngClass]="{ 'disabled-estimate-field': isArchived }"
            pTooltip="Click to restore original RO value - ${{ _estimate.adjustments.actualOrderValue }}"
            tooltipPosition="top" (click)="resetOrderAmountAdjustment($event)"></i>

          <i class="far fa-edit ro-adjust-icon font-gray-85" tooltipPosition="top"
            [ngClass]="{ 'disabled-estimate-field': isArchived }" [escape]="false"
            [pTooltip]="invoiceDistributionTooltip" (click)="open()"></i>
        </ng-template>

        <ng-template appTemplate="overlay" let-close="close">
          <div class="adjust-order-overlay shop-supplies-overlay">
            <div class="overlay-content-wrapper">
              <div class="input-box flex-start-center width-100p flex-column">
                <p class="m-0">Round {{ _estimate?.orderStatus === 'invoice' ? 'Invoice' : 'Estimate' }} total to:</p>
                <app-input id="order-adjust-amount-input" theme="primary"
                  [allowDecimal]="isAdjustAmountFocus ? true : false" [allowNegative]="true" [fontSize]="12"
                  styleClass="pl-0" styleClassInput="pl-0" placeholder="$0.00" [floatingLabel]="false"
                  [value]="roAdjustAmount" [disabled]="isArchived" (appChange)="onAdjustROValueChange($event)"
                  (appFocus)="isAdjustAmountFocus = true" (appBlur)="isAdjustAmountFocus = false"
                  (appEnter)="adjustOrderAmount(close)">
                </app-input>
              </div>
            </div>

            <div class="overlay-footer-wrapper">
              <div class="flex-end-center mt-1">
                <button id="order-adjust-amount-cancel-btn"
                  class="font-13 btn btn-white btn-border overlay-panel-btn flex-center-center p-0 mr-1 pl-2 pr-2"
                  (click)="close()">Cancel</button>

                <button id="order-adjust-amount-save-btn"
                  class="font-13 btn btn-primary overlay-panel-btn flex-center-center p-0 px-3" [disabled]="isArchived"
                  (click)="adjustOrderAmount(close)">
                  Save
                </button>
              </div>
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>

    <div class="ui-g-3 p-1 text-right right-heading b-top-gray-85">
      <span class="font-primary font-600" (click)="openCustomerSidebar()"
        [pTooltip]="(_estimate?.total?.grand > availableLimit && isShowChargeAccountTooltip && isChargeAccountEnabled && finalizeType === 'notFinalized') ? tooltip : ''"
        tooltipPosition="left" [escape]="false" tooltipStyleClass="ticket-tooltip modifier est-pinned"
        [ngClass]="{'warning-800 pointer': ((_estimate?.total?.grand > availableLimit) && isShowChargeAccountTooltip && isChargeAccountEnabled && finalizeType === 'notFinalized')}">
        {{ _estimate?.total?.grand || 0 | currency : usd }}
      </span>
    </div>
  </div>
  <!-- End Estimate total -->

  <!-- Start Paid to date -->
  <div class="ui-g-12 p-0 font-gray-light font-13">
    <div class="font-secondary-900 ui-g-9 p-1 flex-start-center left-heading">Paid to date</div>

    <div class="ui-g-3 p-1 text-right right-heading">
      <span id="est-paid-to-date" class="font-secondary-900"> ({{ (card || 0) + (cash || 0) + (cheque || 0) +
        (creditPayment || 0) + (thirdParty || 0) | currency : usd }}) </span>
    </div>
  </div>
  <!-- End Paid to date -->


  <!-- Start write off -->
  <div class="ui-g-12 p-0 font-gray-light font-13"
    *ngIf="isWriteOffEnable && isRevenueRecognitionSettleEnabled && finalizeType">
    <div class="font-secondary-900 ui-g-9 p-1 flex-start-center left-heading">Write-off</div>

    <div class="ui-g-3 p-1 text-right right-heading">
      <span id="est-paid-to-date" class="font-secondary-900"> {{(writeOffPayment || 0) | currency : usd }}</span>
    </div>
  </div>
  <!-- End write off -->

  <!-- Start overage payment -->
  <div class="ui-g-12 p-0 font-gray-light font-13"
    *ngIf="isRevenueRecognitionSettleEnabled && (finalizeType === 'thirdPartyAccounts' || this.overAgePayment)">
    <div class="font-secondary-900 ui-g-9 p-1 flex-start-center left-heading">Excess Commission</div>

    <div class="ui-g-3 p-1 text-right right-heading">
      <span id="est-paid-to-date" class="font-secondary-900"> {{(overAgePayment || 0) | currency : usd }}</span>
    </div>
  </div>
  <!-- End overage payment -->

  <!-- Start remaining balance -->
  <div class="ui-g-12 p-0 font-gray-light font-13">
    <div class="font-secondary-900 ui-g-9 p-1 flex-start-center font-bold left-heading">
      {{ finalizeType === 'Send to AR' ? 'AR balance' : 'Remaining balance' }}
    </div>

    <div class="ui-g-3 p-1 text-right right-heading b-top-gray-85 b-bottom-gray-85" style="border-bottom-width: 2px">
      <span id="est-remaining-balance" class="font-secondary-900 font-bold">
        {{ renderRemainingAmount() | currency : usd }}
      </span>
    </div>
  </div>
  <!-- End remaining balance -->
</div>
